/**
 * Cookiebar
 * TODO: modal-overlay and responsive
 */
import React, { useState, useEffect, useRef } from 'react';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import clsx from 'clsx';
import { useCookie } from 'ui-component-library/hooks/useCookie';
import Button from '../Button';
/** The cookiebar component for both desktop and mobile devices. */
var Cookiebar = function (_a) {
    var open = _a.open, cookieName = _a.cookieName, hideIfCookieSet = _a.hideIfCookieSet, children = _a.children, buttonText = _a.buttonText;
    var _b = useState(true), expanded = _b[0], setExpanded = _b[1];
    var _c = useCookie(cookieName, 'false'), acceptedCookies = _c[0], setAcceptedCookies = _c[1];
    var scrollRef = useRef(null);
    useEffect(function () {
        if (open && acceptedCookies !== 'true') {
            document.body.classList.add('modal-overlay');
            if (scrollRef.current) {
                disableBodyScroll(scrollRef.current);
            }
        }
        return function () {
            document.body.classList.remove('modal-overlay');
            clearAllBodyScrollLocks();
        };
    }, [open, scrollRef]);
    if (acceptedCookies === 'true' && hideIfCookieSet) {
        // document.body.classList.remove('modal-overlay');
        // clearAllBodyScrollLocks();
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-cid": "Cookiebar", className: "fixed inset-0 z-50 flex items-end justify-center lg:items-center page-overlay" },
            React.createElement("div", { ref: scrollRef, className: "overflow-y-auto scrolling-touch bg-white shadow max-h-4/5 cookiebar lg:rounded-lg" },
                React.createElement("div", { className: clsx('md:pt-6', 'md:px-8', 'md:pb-8', 'p-4') },
                    children,
                    buttonText && (React.createElement("div", { className: clsx('mt-6') },
                        React.createElement(Button, { onClick: function () {
                                setAcceptedCookies('true', {
                                    days: 365,
                                    path: '/',
                                });
                                setExpanded(!expanded);
                                document.body.classList.remove('modal-overlay');
                                clearAllBodyScrollLocks();
                            } }, buttonText))))))));
};
export default Cookiebar;
